import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';

interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  destructive?: boolean;
}

const monoFont = "'IBM Plex Mono', monospace";

export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  destructive = false,
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-sm border-none shadow-lg"
        style={{
          fontFamily: monoFont,
          backgroundColor: '#1e1e1e',
          borderRadius: 0,
          border: '0.5px solid rgba(247,246,242,0.1)',
        }}
      >
        <DialogHeader>
          <DialogTitle
            className="text-sm uppercase font-light tracking-wider"
            style={{ fontFamily: monoFont, color: 'rgba(247,246,242,0.9)' }}
          >
            {title}
          </DialogTitle>
          <DialogDescription
            className="text-xs mt-2"
            style={{ fontFamily: monoFont, color: 'rgba(247,246,242,0.5)' }}
          >
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-row gap-3 mt-4 sm:justify-end">
          <button
            onClick={() => onOpenChange(false)}
            className="uppercase text-xs py-2 px-4 transition-colors"
            style={{
              fontFamily: monoFont,
              color: 'rgba(247,246,242,0.5)',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            {cancelLabel}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
            className="uppercase text-xs py-2 px-4 transition-colors"
            style={{
              fontFamily: monoFont,
              color: destructive ? '#FF3F2D' : 'rgba(247,246,242,0.9)',
              border: 'none',
              backgroundColor: 'transparent',
              cursor: 'pointer',
            }}
          >
            {confirmLabel}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
